import fundaNowClient from '@/client/fundaNowClient'

export default {
  getCurrentCreditEvaluation() {
    return fundaNowClient.call({
      url: '/evaluations/credit-evaluations/current/',
      method: 'GET'
    })
  },
  postCreditEvaluations() {
    return fundaNowClient.call({
      url: '/evaluations/credit-evaluations/',
      method: 'POST'
    })
  },
  postCreditEvaluate(id) {
    return fundaNowClient.call({
      url: `/evaluations/credit-evaluations/${id}/evaluate/`,
      method: 'POST'
    })
  }
}
